export interface GenerateForms721SubmitPayload {
  mod: string
  ejf: string
  periodo: string
  ndc: string
  fic: string
  fic2: string
  idi: string
  numBloques: number
  codification: string
  envioId?: string
}

function toStringValue(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined
  }

  const text = String(value).trim()
  return text.length > 0 ? text : undefined
}

function toNumberValue(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined
  }

  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : undefined
}

export function buildGenerateForms721SubmitPayload(input: any): GenerateForms721SubmitPayload {
  return {
    mod: '721',
    ejf: toStringValue(input?.ejf) as string,
    periodo: toStringValue(input?.periodo) as string,
    ndc: toStringValue(input?.ndc) as string,
    fic: toStringValue(input?.fic) as string,
    fic2: toStringValue(input?.fic2) as string,
    idi: toStringValue(input?.idi) as string,
    numBloques: toNumberValue(input?.numBloques) as number,
    codification: toStringValue(input?.codification) as string,
    envioId: toStringValue(input?.envioId),
  }
}
